import { Box } from '@material-ui/core';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { AutomobileItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/entities/AutomobileItem';
import { CartHeader } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/components/CartHeader';
import { CartItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/components/CartItem/CartItem';
import { CartTotal } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/components/CartTotal';
import { useCartForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/hooks/useCartForm';
import { useArticleTypes } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useArticleTypes';
import { useAutoUpdateCartSummaryData } from '@/components/modules/Application/hooks/useAutoUpdateCartSummaryData';
import { useSetIsDirtyListener } from '@/components/modules/Application/hooks/useSetDirtyListener';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

export const CartForm = () => {
  const { sm } = useScreen();
  const { cart, items, isFormValid, itemFields, cartFormActions } = useCartForm();
  const { defaultFormItem, requiredArticleTypes } = useArticleTypes();

  useAutoUpdateCartSummaryData();

  const { setValue, formState } = useFormContext();
  useSetIsDirtyListener(formState.isDirty);

  useEffect(() => {
    if (!cart) return;
    const needsCartRestoring = items.length === 0 && cart.items.length > 0;
    if (needsCartRestoring) {
      setValue('items', cart.cartItemsToMinimalForm());
      return;
    }
    const needsInitialProductItem = requiredArticleTypes.length === 0;
    if (needsInitialProductItem) {
      setValue('items', [defaultFormItem]);
      return;
    }
  }, []);

  if (!cart) return null;

  const autoInCart = cart.items.length > 0 && cart.items.some((item) => item instanceof AutomobileItem);

  return (
    <CustomPaper fill="paper">
      {sm && <CartHeader />}
      {itemFields.length > 0 &&
        itemFields.map((item, index) => (
          <CartItem
            key={item.id}
            index={index}
            items={items}
            cartFormActions={cartFormActions}
            currency={cart.currency}
          />
        ))}
      <CustomPaper
        fill="grey.light"
        style={{
          margin: '24px 0',
          padding: '12px',
        }}
      >
        <Box display={'flex'} justifyContent={'center'}>
          <StandardButton
            onClick={cartFormActions.appendItem}
            disabled={!isFormValid || autoInCart}
            startIcon={<Icon size={22}>add_circle</Icon>}
          >
            <Text tId={'ADD_NEW_ITEM'} />
          </StandardButton>
        </Box>
      </CustomPaper>
      <CartTotal cartTotal={cart.total() ?? 0} currency={cart.currency} />
    </CustomPaper>
  );
};
